export default __webpack_public_path__ + "1d2808dbde6bb75f3c59ec2b0a3862ef.png";